export default __webpack_public_path__ + "static/media/gou.e4494e1e.png";